import { WalkingSession } from '@spike/new-booking-model';
import { DataVaraible } from 'model/NewMultipleBooking';
import { SessionBusinessArea } from 'model/ServiceSession';
import { Moment } from 'moment-timezone';

// The backend only counts saved appointments, so pets already placed in a session earlier
// in the same drawer have to be added on top of its number.
const draftPetsInSession = (
    session: WalkingSession,
    drafts: Array<DataVaraible>,
    serviceId: number,
    sessionDate: Moment,
    tz: string,
    flow: SessionBusinessArea
): number => {
    const day = sessionDate.clone().tz(tz).format('YYYY-MM-DD');

    return drafts.filter(entry => {
        if (entry.itemData?.flow !== flow || entry.service?.service?.id !== serviceId) return false;
        if (!entry.date?.isValid()) return false;

        const start = entry.date.clone().tz(tz);
        if (start.format('YYYY-MM-DD') !== day) return false;

        // A linked entry belongs to its session only. An unlinked one (a typed time) falls back
        // to staff plus exact start time, the same match the backend uses.
        const sessionId = entry.service?.serviceSessionId;
        if (sessionId != null) return sessionId === session.id;

        return entry.staffId === session.staffId && start.format('HH:mm') === session.startTime;
    }).length;
};

export const withDraftOccupancy = (
    sessions: Array<WalkingSession>,
    drafts: Array<DataVaraible>,
    serviceId: number | undefined,
    sessionDate: Moment | undefined,
    tz: string,
    flow: SessionBusinessArea
): Array<WalkingSession> => {
    if (!serviceId || !sessionDate?.isValid() || drafts.length === 0) return sessions;

    return sessions.map(session => {
        if (session.bookedPets == null) return session;

        const draftPets = draftPetsInSession(session, drafts, serviceId, sessionDate, tz, flow);

        return draftPets === 0 ? session : { ...session, bookedPets: session.bookedPets + draftPets };
    });
};
